export const formatNumber = (number) => {
  // If string then convert to number
  if (typeof number === "string") {
    number = parseFloat(number);
  }

  // If the value is not a valid number, return it as-is
  if (isNaN(number)) {
    return number;
  }

  return number.toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};
